<script>
import MultipleChecks from '@wielink-application/shared/vue/components/form/input-only/multiple-checks.vue'

export default MultipleChecks;
</script>